module.exports = __webpack_public_path__ + "public/img/zs2.321d5108.png";